let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0TxbS")).then(() => parcelRequire('alQnK'));